import type { AxiosRequestConfig } from "axios"

import { instance } from "../axios"
import type { SendingConfigurationResponse } from "./types"

// 取得預覽與寄件人管理設定
export function getSendingConfiguration(config: AxiosRequestConfig = {}) {
    return instance.request<SendingConfigurationResponse>({
        url: "/systems/sending-configuration/",
        method: "get",
        ...config,
    })
}

// 更新預覽與寄件人管理設定
export function updateSendingConfiguration(config: AxiosRequestConfig = {}) {
    return instance.request<void>({
        url: "/systems/sending-configuration/",
        method: "put",
        ...config,
    })
}
